import { Button, Grid, Stack, Typography } from '@mui/material';

import { Icon, Mask } from '@hapvida/hapvida-core-components';

import { NEW_COLORS } from '@hapvida/hapvida-core-components/src/themes/colors/newColors';

import {
  PLAN_TYPE_COLOR,
  PLAN_TYPE_NAME,
} from '@flows/private/partnerCompanies/pages/PartnerCompanyList/constants/contractTypeEnum';
import { PartnerCompanyStatusChip } from '@flows/private/partnerCompanies/pages/PartnerCompanyList/components/PartnerCompaniesStatusChip';
import { PartnerCompanyTypeChip, ProfileDetailsButton } from '@components';
import { useSelectPartnerCompany } from '@flows/private/partnerCompanies/pages/PartnerCompanyList/hooks';

import { CardItem } from './styles';
import type { PartnerCompanyItemProps } from './types';

export function PartnerCompanyItem({
  partnerCompanyData,
}: Readonly<PartnerCompanyItemProps>) {
  const { handleSelectPartnerCompany } = useSelectPartnerCompany();

  const handleOnClick = () => {
    handleSelectPartnerCompany({
      ...partnerCompanyData,
    });
  };

  const {
    complement,
    isMainPartnerCompany,
    legal,
    mainPartnerCompany,
    partnerCompany,
    partnerCompanyStatus,
    planType,
    document,
    profile,
  } = partnerCompanyData;

  return (
    <Grid item xs={12}>
      <CardItem>
        <Stack flexDirection="row" justifyContent="space-between">
          <Stack alignItems="center" flexDirection="row" gap={1}>
            <Typography fontWeight={700}>{partnerCompany}</Typography>
            <PartnerCompanyTypeChip
              fontSize="12px"
              isMainPartnerCompany={isMainPartnerCompany}
              size="small"
            />
          </Stack>

          <ProfileDetailsButton
            profileId={profile?.id ?? ''}
            profileName={profile?.name ?? ''}
          />
        </Stack>
        <Stack>
          {legal && (
            <Typography
              fontWeight={700}
              textTransform="uppercase"
              variant="text"
              title={legal}
            >
              {legal}
            </Typography>
          )}
          {document && (
            <Typography fontWeight={700} variant="smallText">
              {Mask.cnpj(document)}
            </Typography>
          )}
          {complement && (
            <Typography fontWeight={400} variant="smallText">
              {complement}
            </Typography>
          )}
        </Stack>
        <Stack flexDirection="row" justifyContent="space-between">
          <Typography fontWeight={700} display="flex">
            <Typography fontWeight={400}>Mãe: </Typography>{' '}
            {mainPartnerCompany ?? '-'}
          </Typography>
          {planType ? (
            <Typography
              fontWeight={700}
              color={PLAN_TYPE_COLOR[planType]}
              variant="text"
            >
              {PLAN_TYPE_NAME[planType]}
            </Typography>
          ) : (
            <Typography fontWeight={700}>-</Typography>
          )}
          <Stack maxWidth={90}>
            <PartnerCompanyStatusChip
              fontSize="12px"
              status={partnerCompanyStatus}
              size="small"
            />
          </Stack>
        </Stack>
        <Button
          onClick={handleOnClick}
          variant="outlined"
          fullWidth
          color="secondary"
          endIcon={
            <Icon
              name="actions-b2b-chevron-right"
              color={NEW_COLORS.PRIMARY[700]}
              size={24}
            />
          }
        >
          Selecionar e avançar
        </Button>
      </CardItem>
    </Grid>
  );
}
